export default __webpack_public_path__ + "static/media/9.b3e29341.png";